module.exports = __webpack_public_path__ + "img/Icon awesome-user-circle.84a1e4c9.svg";